<ng-container *ngIf="busy$ | async">
  <div class="overlay overlay-backdrop"></div>
  <div class="overlay overlay-content d-flex justify-content-center align-items-center">
    <img src="/assets/brand-spinner.gif" class="ua-spinner" alt="Loading...">
  </div>
</ng-container>
